'use client'
import React, { ReactElement } from 'react'

interface TableBottomControls extends React.HTMLAttributes<HTMLDivElement> {
    children: ReactElement
}

export const TableBottomControls = ({ children, ...props }: TableBottomControls): ReactElement => {
    return (
        <div className="table-bottom-controls border border-border-default h-14 flex" {...props}>
            {children}
        </div>
    )
}
